<h1>Pages</h1>
<ol>
  <li *ngFor="let page of pages">
    <a (click)="goToPage(page.slug)">
        <h2 font-bold>{{page.title}}</h2>
    </a>
  </li>
</ol>
